import React,{Component}from 'react'
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
export default class CustomerCard extends Component{
    constructor(props){
        super(props)
        this.state={
      
        }
    }
    render(){
        return(
          <>
            <Box  elevation={3} sx={{backgroundColor: 'white',}}>
   
            <Grid container spacing={2}>
            <Grid item md={6}>
            <Grid container spacing={2}>
            <Grid item xs={1} sm={1} md={1}/>
            <Grid item xs={3} sm={3} md={3}><p style={{fontSize:15}}>Product Name</p></Grid>
            <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
            <Grid item xs={4} sm={4} md={4}><p style={{fontWeight:'600',fontSize:15}}>{this.props.productname}</p></Grid>
            <Grid item xs={3} md={3} sm={3}/>

            <Grid item xs={1} sm={1} md={1}/>
            <Grid item xs={3} sm={3} md={3}><p> Product Key </p></Grid>
            <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
            <Grid item xs={5} sm={5} md={5}><p>{this.props.productkey}</p><br/></Grid>
            <Grid item xs={2} md={2} sm={2}/> 

            <Grid item xs={1} sm={1} md={1}/>
            <Grid item xs={3} sm={3} md={3}><p> No.of System </p></Grid>
            <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
            <Grid item xs={5} sm={5} md={5}><p>{this.props.noofsystem}</p><br/></Grid>
            <Grid item xs={2} md={2} sm={2}/> 
            </Grid>
            </Grid>

            <Grid item md={6}>
            <Grid container spacing={2}>
            <Grid item xs={1} sm={1} md={1}/>
            <Grid item xs={3} sm={3} md={3}><p style={{fontSize:15}}>No.of.MobileUser </p></Grid>
            <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
            <Grid item xs={4} sm={4} md={4}><p style={{fontWeight:'600',fontSize:15}}>{this.props.noofmobileuser}</p></Grid>
            <Grid item xs={3} md={3} sm={3}/>

            <Grid item xs={1} sm={1} md={1}/>
            <Grid item xs={3} sm={3} md={3}><p> MobileNo </p></Grid>
            <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
            <Grid item xs={5} sm={5} md={5}><p>{this.props.phonenumber}</p><br/></Grid>
            <Grid item xs={2} md={2} sm={2}/> 
            </Grid>
            </Grid>
            </Grid>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon onClick={this.props.onClick}/>}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
              <Typography>Modules</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <label>modules:{this.props.modules}</label>
            </AccordionDetails>
          </Accordion>
          </Box>   
          <br/><br/><br/><br/>
          <Grid container spacing={2}>
          <Grid item md={12}/>
        </Grid>
        </>
        )
    }
        
}